import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    <MKTypography variant="h2" mb={3} color="dark">
                        Curățenie birouri, firme și spații comerciale
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Un mediu de lucru igienizat nu este doar o carte de vizită pentru clienți,
                        ci și o condiție esențială pentru sănătatea și randamentul echipei
                        dumneavoastră.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Studiile efectuate de universități de prestigiu, precum Universitatea din
                        Arizona, au demonstrat că un birou obișnuit poate găzdui de până la 400 de
                        ori mai multe bacterii decât colacul unui vas de toaletă dacă nu este
                        dezinfectat periodic.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Aceste microorganisme sunt responsabile pentru o mare parte din absențele
                        medicale ale angajaților, afectând direct productivitatea companiei.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Echipa Doral Cleaning oferă soluții complete de curățenie în birouri,
                        adaptate nevoilor specifice fiecărei afaceri, de la firme mici, până la
                        centre comerciale de mari dimensiuni.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Ne ocupăm de tot ce înseamnă întreținere, astfel încât dumneavoastră să vă
                        puteți concentra exclusiv pe obiectivele companiei, eliminând grija
                        logistică a curățeniei.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Folosim tehnologii moderne și substanțe cu spectru larg de acțiune care
                        garantează un mediu sigur și primitor.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://doral-cleaning.ro/static/media/DSC09823.51fae6a99fd3c06e0d68.webp"
                        alt="Curățenie birouri realizata de un membru al echipei Doral Cleaning"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    <MKTypography variant="body1" color="text" mb={2}>
                        Colaborarea cu o firmă de curățenie birouri profesională elimină stresul
                        legat de recrutarea personalului, gestionarea concediilor sau achiziția
                        recurentă de consumabile.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Ne asumăm întreaga responsabilitate logistică: de la echipamente performante
                        de aspirare și spălare până la detergenți industriali certificați.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Externalizarea acestui serviciu este o strategie adoptată de peste 80% din
                        companiile moderne, conform rapoartelor din industria de facility
                        management, deoarece reduce costurile administrative cu până la 20%.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Vă oferim confortul unui sediu curat permanent, gestionând integral
                        aprovizionarea și materialele necesare, integrând aceste activități într-un
                        flux de{" "}
                        <a
                            href="https://www.doral-cleaning.ro/curatenie-generala"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățenie generală
                        </a>{" "}
                        sau întreținere periodică.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Astfel, managementul firmei scapă de povara monitorizării stocurilor de
                        detergenți sau a stării utilajelor de curățat, lăsând aceste sarcini în mâna
                        experților.
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Siguranța spațiului dumneavoastră este prioritară pentru noi, mai ales când
                        este vorba de accesul în zone cu documente confidențiale sau echipamente
                        scumpe.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Personalul nostru este calificat, echipat corespunzător și verificat riguros
                        din punct de vedere al cazierului și al antecedentelor profesionale.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Toți angajații Doral Cleaning lucrează cu acte în regulă și beneficiază de
                        instruire constantă privind normele de protecția muncii și tehnici specifice
                        pentru diverse suprafețe.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Această abordare vă oferă garanția unei colaborări stabile, bazate pe
                        încredere și profesionalism, eliminând riscurile asociate cu munca
                        nedeclarată sau personalul neinstruit.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        O echipă motivată și bine pregătită este singura cale prin care putem livra
                        constant servicii de curățenie în birouri la cele mai înalte standarde de pe
                        piață.
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Adaptăm planul de igienizare în funcție de traficul, dimensiunea și
                        specificul activității firmei dumneavoastră.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Menținem ordinea pe birouri și echipamente periferice, intervenind cu
                        discreție maximă pentru a nu întrerupe apelurile telefonice sau ședințele
                        importante.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        De la curățarea suprafețelor de lucru până la dezinfectarea punctelor de
                        contact intens, precum mânerele ușilor sau butoanele liftului, acoperim
                        toate etapele necesare pentru un mediu de lucru sănătos.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        În spațiile comerciale, accentul cade pe{" "}
                        <a
                            href="https://www.doral-cleaning.ro/curatare-pardoseli"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curatare pardoseli
                        </a>{" "}
                        și eliminarea rapidă a urmelor lăsate de clienți, asigurând o imagine
                        impecabilă în orice moment al zilei.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Strategia noastră include utilizarea de liste de verificare personalizate
                        pentru fiecare locație în parte, garantând că niciun colț nu rămâne
                        neigienizat.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Întreținerea pardoselilor, a mochetei și gestionarea deșeurilor
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Aspirăm mocheta cu echipamente care rețin praful fin și microparticulele,
                        spălăm pardoselile dure cu detergenți cu uscare rapidă și colectăm deșeurile
                        zilnic.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Ne asigurăm că resturile menajere sunt eliminate corect, iar coșurile de
                        gunoi sunt igienizate temeinic și dotate cu saci noi.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Această rutină menține un aer proaspăt în întreaga locație și previne
                        acumularea de mirosuri neplăcute.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Curățarea regulată a mochetei este esențială pentru calitatea aerului
                        interior, prevenind acumularea alergenilor care pot declanșa rinite sau astm
                        angajaților sensibili.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Utilizăm metode de curățare care prelungesc durata de viață a materialelor
                        textile, protejând investiția făcută în amenajarea sediului.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://doral-cleaning.ro/static/media/DSC09866.bd8b3fc0e1c569906837.webp"
                        alt="Curatare birou si mocheta"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    <MKTypography variant="h3" mb={3} color="dark">
                        Igienizarea grupurilor sanitare și a spațiilor de relaxare
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Curățăm și dezinfectăm băile și zonele de bucătărie ale biroului, unde
                        riscul de contaminare încrucișată este cel mai ridicat.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Completăm periodic stocurile de consumabile, precum hârtia igienică,
                        prosoapele de hârtie și săpunul lichid, pentru un confort sporit al
                        personalului dumneavoastră.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Spațiile de relaxare sau bucatariile sunt tratate cu o atenție specială,
                        folosind produse sigure pentru zonele unde se consumă alimente.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        O toaletă curată și o bucătărie bine întreținută sunt indicatori direcți ai
                        respectului pe care o companie îl poartă angajaților săi, contribuind la
                        moralul general al colectivului.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://doral-cleaning.ro/static/media/6-4-galerie-postconstructor.2cff085c960093975d73.webp"
                        alt="igienizare grupuri sanitare birouri"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    <MKTypography variant="h3" mb={3} color="dark">
                        Abonamente și oferte curățenie birouri pentru eficiență maximă
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Știm că predictibilitatea costurilor este vitală pentru orice plan de
                        afaceri bine structurat. De aceea, oferim pachete personalizate și reduceri
                        lunare atractive pentru partenerii pe termen lung.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Beneficiați de o reducere de 10% pentru toate serviciile contractate prin
                        abonamente de mentenanță, asigurându-vă un preț corect și un suport tehnic
                        continuu.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        În cadrul unui abonament, oferim flexibilitate în programarea
                        intervențiilor, fie că preferați curățenia de dimineață, de seară sau în
                        timpul weekend-ului.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Birou impecabil și angajați fericiți cu Doral Cleaning
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Ai nevoie de serviciile unor profesioniști care practică prețuri corecte și
                        livrează rezultate palpabile? Ai ajuns unde trebuia deoarece echipa Doral
                        Cleaning transformă curățenia biroului dintr-o grijă administrativă
                        obositoare într-un avantaj competitiv real.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Suntem partenerul dumneavoastră discret, eficient și dedicat excelenței în
                        igienă, pregătiți să intervenim în orice moment pentru a reda strălucirea
                        spațiului dumneavoastră de lucru.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Cere o oferta personalizată!
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Fiecare spațiu are nevoi diferite. Nu te mulțumi cu soluții standard. Cere o
                        ofertă personalizată astăzi și hai să discutăm concret despre proiectul tău!
                    </MKTypography>
                    <MKTypography variant="body1" color="text">
                        Contactează-ne la telefon{" "}
                        <a
                            href="tel:0757093579"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            0757 093 579
                        </a>
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
